import { create } from "zustand";
import { getDict, type DictItem } from "@/services/common";

interface DictState {
  dictMap: Record<string, DictItem[]>;
  loading: boolean;
  fetchDict: (dictType: string, force?: boolean) => Promise<DictItem[]>;
}

export const useDictStore = create<DictState>((set, get) => ({
  dictMap: {},
  loading: false,

  fetchDict: async (dictType: string, force = false) => {
    const { dictMap, loading } = get();

    // 如果已经有该类型数据且不是强制更新，直接返回
    if (dictMap[dictType]?.length > 0 && !force) {
      return dictMap[dictType];
    }

    // 避免重复请求
    if (loading) return dictMap[dictType] || [];

    set({ loading: true });
    try {
      const res = await getDict({ dictType });
      const list = res?.list || [];
      set({
        dictMap: { ...dictMap, [dictType]: list },
        loading: false,
      });
      return list;
    } catch {
      set({ loading: false });
      return [];
    }
  },
}));
